export default __webpack_public_path__ + "static/media/IMG_3142.4ec1243f.jpeg";